import {AppbarOptions} from "../../model/appbar-options";
import milleEtUnParcoursLogo from '../../assets/1001parcours_logo.png';
import {MeupCommonOptions} from "../../model/meup-common-options";
import {authorizationService} from "../../services/authorization.service";
import {APPBAR_ELEMENTS} from "./appbar-elements";
import {SIDEBAR_MENU_ITEMS} from "../sidebar/sidebar-menu-items";

class Appbar {
    private appbarHTMLElement?: HTMLElement;
    private menuButtonElement?: HTMLElement;
    private titleElement?: HTMLElement;
    private meupCommonOptions: MeupCommonOptions;
    private options: AppbarOptions;

    constructor() {
    }

    setOptions(meupCommonOptions: MeupCommonOptions, appbarOptions: AppbarOptions) {
        this.meupCommonOptions = meupCommonOptions;
        this.options = appbarOptions;
    }

    render = (): void => {
        this.appbarHTMLElement = document.createElement('header');
        this.appbarHTMLElement.setAttribute('id', 'milleetunparcours-header');

        this.appbarHTMLElement.innerHTML = `
        <div class="milleetunparcours-header-container">
            <div class="milleetunparcours-header-logo-button-container">
                <button id="milleetunparcours-menu-button" class="hamburger-menu hamburger--spin" type="button" aria-label="Menu">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
                <div class="milleetunparcours-header-logo-wrapper">
                    <img width="80px" class="milleetunparcours-header-logo-1001-parcours" src="${milleEtUnParcoursLogo}" alt="1001parcours logo">
                </div>
                <div class="milleetunparcours-header-title-wrapper" id="milleetunparcours-appbar-title"></div>
            </div>
            <div class="milleetunparcours-header-content-container">
                <div class="milleetunparcours-header-menu-wrapper">
                    <div class="milleetunparcours-header-menu-item" data-appbar-element="recherche">
                        <form action="https://1001parcours.cci.fr/experience/totara/catalog/explore.php" method="get">
                            <input name="catalog_fts" class="milleetunparcours-header-search-bar" type="text" placeholder="Rechercher">
                        </form>
                    </div>
                    <div class="milleetunparcours-header-menu-item" data-appbar-element="notifications">
                        <a href="https://1001parcours.cci.fr/experience/message/output/popup/notifications.php">Notifications</a>
                    </div>
                    <div class="milleetunparcours-header-menu-item" data-appbar-element="messages">
                        <a href="https://1001parcours.cci.fr/experience/message/index.php">Messages</a>
                    </div>
                    <div class="milleetunparcours-header-menu-item" data-appbar-element="mon-compte">
                        <a href="https://1001parcours.cci.fr/annuaire/mon-compte">Mon compte</a>
                    </div>
                    <div class="milleetunparcours-header-menu-item" data-appbar-element="connexion">
                        <a href="https://1001parcours.cci.fr/fr/connexion">Connexion</a>
                    </div>
                </div>
            </div>
        </div>
        `;

        document.body.prepend(this.appbarHTMLElement);

        this.menuButtonElement = document.getElementById('milleetunparcours-menu-button');
        this.titleElement = document.getElementById('milleetunparcours-appbar-title');
        this.bindEvents();
    };

    public refreshMenuButtonState = (active: boolean) => {
        this.menuButtonElement.classList.toggle('is-active', active);
    }

    public setTitle = (title: string) => {
        this.titleElement.innerHTML = title;
    }

    private bindEvents = (): void => {
        //click bouton
        this.menuButtonElement.addEventListener('click', () => {
            this.options.onMenuButtonClick();
        });
    };

    public refreshAfterUserRoleAndStatutUpdate(): void {
        // Toggle appbar menu items visibility via CSS class
        APPBAR_ELEMENTS.forEach(element => {
            const el = this.appbarHTMLElement.querySelector(`[data-appbar-element="${element.id}"]`);
            if (el) {
                const isVisible = authorizationService.isAuthorized(element.authorized);
                el.classList.toggle('visible', isVisible);
            }
        });

        // Toggle menu button visibility via CSS class (based on sidebar items)
        const hasVisibleSidebarItems = SIDEBAR_MENU_ITEMS.some(item =>
            authorizationService.isAuthorized(item.authorized)
        );
        this.menuButtonElement.classList.toggle('visible', hasVisibleSidebarItems);
    }
}

export default Appbar;
